import React from "react";
import {
    makeStyles,Paper
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    paper: {
        width: "100%",
        minHeight: 700,
        marginBottom: theme.spacing(2),
    },
    frame: {
        width: 500,
        minHeight: 300,
    }
}));
export default function ManualPage() {
    const classes = useStyles();
    return (<>
        <Paper className={classes.paper + " p-5"}>
            <div className="manualPage">
                <div className={classes.frame + " video embed-responsive embed-responsive-16by9 mb-5"}>
                    <iframe title={`title`} className="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" ></iframe>
                </div>
                {/* <h3><a href="#">使用教學PDF下載</a></h3> */}
            </div>
        </Paper>
    </>)
}  